// extracted by mini-css-extract-plugin
export default {"subscriptionHeading":"SubscriptionHeading_subscriptionHeading__ws-Y7"};